/* eslint-disable @typescript-eslint/no-unused-vars */
// @ts-nocheck
/**
 * This file Copyright (c) 2010-2021 Magnolia International
 * Ltd.  (http://www.magnolia-cms.com). All rights reserved.
 *
 *
 * This program and the accompanying materials are made
 * available under the terms of the Magnolia Network Agreement
 * which accompanies this distribution, and is available at
 * http://www.magnolia-cms.com/mna.html
 *
 * Any modifications to this file must keep this entire header
 * intact.
 *
 */
// Auto generated file, don't change manually

import type {
  Asset,
  Rendition
} from '../../../magnolia/lib/MagnoliaAsset';
import {
  transformNode,
  transformResults
} from '../../../magnolia/lib/MagnoliaPropertyHelper';

export default interface Expandable {
  contentToDisplay: any;
  defaultMode ? : string;
  collapsedText ? : string;
  expandedText ? : string;
  modeTextColor ? : number;
  previewHeight ? : string;
  dataABId ? : string;
  metadata ? : any;
}

export const Props = {
  contentToDisplay: Object,
  defaultMode: String,
  collapsedText: String,
  expandedText: String,
  modeTextColor: Number,
  previewHeight: String,
  dataABId: String,
  metadata: Object,
}

export const WrapperProps = {
  contentToDisplay: Object,
  defaultMode: String,
  collapsedText: String,
  expandedText: String,
  modeTextColor: Number,
  previewHeight: String,
  dataABId: String,
  metadata: Object,
}

export class ExpandableBuilder {
  static build(props: any) {
    props = transformNode(JSON.parse(JSON.stringify(props)));
    class ExpandableInstance implements Expandable {
      defaultMode ? : string;
      collapsedText ? : string;
      expandedText ? : string;
      modeTextColor ? : number;
      previewHeight ? : string;
      dataABId ? : string;
      contentToDisplay: any;
      metadata ? : any;

      constructor(props: any) {
        Object.assign(this, props);

      }
    }
    return new ExpandableInstance(props);
  }
}
